import moment from 'moment'

export default {
  filter: function (list) {
    const fl = []
    const tags = {
      pneu: [],
      bact: []
    }
    const getUniqueMOS = (mos) => {
      const result = []
      mos.forEach(
        mo => {
          if (result.indexOf(mo.code) === -1) {
            result.push(mo.code)
          }
        }
      )
      result.sort()
      return result
    }

    for (let i = 0; i !== list.length; ++i) {
      const l = list[i]
      const tag = l.itb == null ? tags.bact : tags.pneu
      const mos = getUniqueMOS(l.inf.microOrganisms)
      const bd = moment(l.pat.birthdate)
      const uf = l.uf.ufType
      const mo = bd.month()
      const ye = bd.year()
      const sex = l.pat.sex
      const ep = l.inf.episod
      const ent = l.inf.entrance_v2

      const k = `${l.estb.c}/${uf}/${mo}${ye}/${sex}/${ep}/${ent}/${mos.join('/')}`
      const t = tag.indexOf(k)
      if (t === -1) {
        fl.push(l)
        tag.push(k)
      }
    }
    return fl
  }
}
